import { useLang } from "../lib/i18n";
import { Button } from "../components/ui/button";
import { Download, X } from "lucide-react";

export default function InstallButton() {
  var { t } = useLang();
  return (
    <Button data-testid="install-app-button" variant="ghost" size="sm" onClick={function() {
      var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent || "");
      var isSafari = /Safari/.test(navigator.userAgent || "") && !/Chrome/.test(navigator.userAgent || "");
      var msg = isIOS && isSafari
        ? "Safari: Tocca Condividi > Aggiungi alla schermata Home"
        : isIOS
        ? "Apri in Safari per aggiungere alla Home"
        : "Chrome: Menu (3 puntini) > Installa app";
      alert(msg);
    }} className="text-emerald-600 hover:text-emerald-700 hover:bg-emerald-50">
      <Download className="w-4 h-4 mr-1.5" /> {t.install}
    </Button>
  );
}
